<template>
  <div :class="{ 'text-xs-center': !loaded }" class="content--bg--2">
    <v-progress-circular
      v-if="!loaded"
      :width="1"
      :size="50"
      color="primary"
      indeterminate
    ></v-progress-circular>

    <line-chart
      v-if="count && loaded"
      :data="chartdata"
      :options="options"
      style="position: relative; height:60px;"
      class="chart-border"
    ></line-chart>
    <div v-if="loaded" class="display-3 font-weight-bold pt-3">{{ count }}</div>
    <div v-if="loaded" class="subtitle-2 text--secondary pb-3">
      авторизаци{{ endingWord(count, ["я", "и", "й"]) }} с
      {{ filterParams.range.startDate | date("DD.MM.YYYY") }} по
      {{ filterParams.range.endDate | date("DD.MM.YYYY") }}
    </div>
    <router-link
      v-if="!['xs'].includes($vuetify.breakpoint.name) && loaded"
      :to="{
        name: 'statisticsGeneral',
        params: { hotspotName: hotspotName, hotspot_id: hotspot_id }
      }"
      class="subtitle-2 font-weight-medium link layout align-center mb-3 text--primary"
    >
      <icon-arrow-right class="mr-2"></icon-arrow-right>
      <span>К статистике</span>
    </router-link>
  </div>
</template>

<script>
import RequestApi from "../../modules/requestApi";
import LineChart from "../common/LineChart.js";
import IconArrowRight from "../icon/IconArrowRight.vue";
import Common from "../../modules/common";
import moment from "moment";

export default {
  name: "StatisticsAuthWidget",

  components: {
    IconArrowRight,
    LineChart
  },

  props: {
    // hotspotName хотспота
    hotspotName: {
      type: String,
      required: true
    },
    // id хотспота
    hotspot_id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    loaded: true,
    // опции графика
    options: {
      responsive: true,
      maintainAspectRatio: false,
      tooltips: {
        enabled: true
      },
      scales: {
        xAxes: [
          {
            display: false
          }
        ],
        yAxes: [
          {
            display: false
          }
        ]
      },
      elements: {
        rectangle: {
          borderWidth: 0
        }
      },
      legend: {
        display: false
      }
    },
    // параметры для запроса данных
    filterParams: {
      // тип детализации графика
      chartTypeDetail: "day",
      range: {
        startDate: moment().subtract(1, "month"),
        endDate: new Date()
      }
    },
    // данные по авторизациям для графика
    chartdata: {},
    // количество авторизаций
    count: 0
  }),

  mounted() {
    this.statChartData();
  },

  methods: {
    /**
     * Получение данных из базы
     */
    statChartData() {
      this.loaded = false;
      RequestApi.statChartData({
        ...this.filterParams,
        hotspotName: this.hotspotName
      })
        .then(data => {
          // если всего одно значение, добавляем null, чтобы график заполнился
          if (data.length === 1) {
            data.push({ minDate: null, cnt: 0 });
          }

          this.chartdata = {
            labels: data.map(
              item => `${moment(item.minDate).format("DD.MM.YYYY")}`
            ),
            datasets: [
              {
                label: "",
                backgroundColor: this.$store.getters.themeDark
                  ? "#2a395a"
                  : "#e6f6fe",
                borderColor: this.$store.getters.themeDark
                  ? "#ffffff"
                  : "#005CFF",
                pointBackgroundColor: "transparent",
                pointBorderColor: "transparent",
                pointBorderWidth: 0,
                borderWidth: 2,
                data: data.map(item => item.cnt),
                lineTension: 0
              }
            ]
          };

          data.forEach(item => {
            this.count += parseInt(item.cnt);
          });

          this.loaded = true;
        })
        .catch(error => {
          this.error = error;
        });
    },

    // формирует окончание для слова
    endingWord(cnt, endingArray) {
      return Common.endingWord(cnt, endingArray);
    }
  }
};
</script>
